var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffQ113(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.897,
    height: 58.2,
    viewBox: "0 0 53.897 58.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(0 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M1.2,0H45.849a1.2,1.2,0,0,1,1.2,1.2V55.8a1.2,1.2,0,0,1-1.2,1.2H1.2A1.2,1.2,0,0,1,0,55.8V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(4.151)",
    fill: "#e2e4e5",
    stroke: "#e2e4e5",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 37.363,
    height: 48.072,
    rx: 1.2,
    transform: "translate(9.687 4.807)",
    fill: "#fff",
    stroke: "#3a484d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "flame",
    transform: "translate(12.459 38.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.129,12.728A9.876,9.876,0,0,1,.423,10.335,5.39,5.39,0,0,1,.1,7.211a6.715,6.715,0,0,1,1.353-2.89,2.771,2.771,0,0,0,.706,2.044A4.831,4.831,0,0,1,3.276,2.336,8.413,8.413,0,0,1,6.864,0a2.861,2.861,0,0,0-.5,2.744,11.41,11.41,0,0,0,1.324,2.6,5.772,5.772,0,0,1,1,2.686,9.358,9.358,0,0,0,.735-1.547,3.036,3.036,0,0,0,.118-1.693,4.327,4.327,0,0,1,.971,2.1,8.769,8.769,0,0,1,.029,2.481,6.174,6.174,0,0,1-.853,2.6,4.908,4.908,0,0,1-2.559,1.9A5.85,5.85,0,0,1,2.129,12.728Z",
    transform: "translate(0)",
    fill: "#f3705a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.943,7.911A2.881,2.881,0,0,0,5.414,3.824c0-.029-.029-.029-.029-.058a2.934,2.934,0,0,1-.735,2.569,2.709,2.709,0,0,0-.265-2.219c-.353-.671-.853-1.285-1.235-1.927A3.085,3.085,0,0,1,2.649,0,3.847,3.847,0,0,0,1.237,2.16a3.882,3.882,0,0,0,.294,2.569,1.915,1.915,0,0,1-.794-1.4A2.993,2.993,0,0,0,0,5.342,2.976,2.976,0,0,0,1.943,7.911Z",
    transform: "translate(2.421 5.897)",
    fill: "#ffd15c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "drop",
    transform: "translate(33.228 39.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M4.983,4.539l0-.006L2.626.03a.057.057,0,0,0-.1,0L.172,4.533l0,.006A2.6,2.6,0,0,0,.241,6.554,2.628,2.628,0,0,0,1.727,7.928a2.664,2.664,0,0,0,.847.165h0a2.666,2.666,0,0,0,.847-.165A2.629,2.629,0,0,0,4.911,6.554,2.6,2.6,0,0,0,4.983,4.539Z",
    transform: "translate(0)",
    fill: "#c4d1e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M2.757,7.575A2.913,2.913,0,0,1,1.873,5.5a.059.059,0,0,1,0-.008L2.506,0,.172,4.466l0,.006A2.6,2.6,0,0,0,.241,6.487,2.628,2.628,0,0,0,1.727,7.861a2.664,2.664,0,0,0,.847.165h0A2.666,2.666,0,0,0,3.2,7.933,2.994,2.994,0,0,1,2.757,7.575Z",
    transform: "translate(0)",
    fill: "#acb9ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M2.513,2.257l0-.006L1.349.03a.057.057,0,0,0-.1,0L.088,2.25l0,.006A1.31,1.31,0,0,0,.121,3.272a1.324,1.324,0,0,0,.749.693,1.344,1.344,0,0,0,.427.083h0a1.344,1.344,0,0,0,.427-.083A1.326,1.326,0,0,0,2.513,2.257Z",
    transform: "translate(6.113 3.424)",
    fill: "#acb9ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M1.673,2.257l0-.006L.51.03A.057.057,0,0,0,.46,0h0L0,2.637a.057.057,0,0,0,0,.007A1.447,1.447,0,0,0,.382,3.7,1.474,1.474,0,0,0,.77,4c.04-.011.079-.023.118-.038A1.326,1.326,0,0,0,1.673,2.257Z",
    transform: "translate(6.952 3.49)",
    fill: "#c4d1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M1.708,1.51.934.03a.057.057,0,0,0-.1,0L.06,1.51l0,.006A.9.9,0,0,0,.592,2.678a.917.917,0,0,0,.291.057h0a.916.916,0,0,0,.291-.057A.9.9,0,0,0,1.71,1.516Z",
    transform: "translate(4.605 7.745)",
    fill: "#acb9ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M1.163,1.516l0-.006L.387.03A.056.056,0,0,0,.319,0L0,1.857a.063.063,0,0,0,0,.008,1.017,1.017,0,0,0,.412.865.915.915,0,0,0,.216-.051A.9.9,0,0,0,1.163,1.516Z",
    transform: "translate(5.152 7.745)",
    fill: "#c4d1e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,0H21.543a2.585,2.585,0,0,1,2.595,2.575h0a2.585,2.585,0,0,1-2.595,2.575H15.288A2.418,2.418,0,0,0,12.86,7.56h0a2.418,2.418,0,0,0,2.427,2.409H28.022",
    transform: "translate(0 13.048)",
    fill: "none",
    stroke: "#f3735a",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0H13.809A2.413,2.413,0,0,1,16.23,2.4h0a2.413,2.413,0,0,1-2.422,2.4H5.758a2.413,2.413,0,0,0-2.422,2.4h0a2.413,2.413,0,0,0,2.422,2.4H25.875",
    transform: "translate(28.022 23.017)",
    fill: "none",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M.5,29.515V0",
    transform: "translate(27.868 22.677)",
    fill: "none",
    stroke: "#3a484d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffQ113);
export default __webpack_public_path__ + "static/media/off_Q1_13_.e2bfa3ab615136277e1c27f81683d7ff.svg";
export { ForwardRef as ReactComponent };